log = require 'loglevel'
BaseManager = require 'BaseManager'

class EventManager extends BaseManager

  constructor: ->

    # this is a Polyfill
    try
      new CustomEvent('test')
    catch e
      CustomEvent = (event, params) ->
        params = params or
          bubbles: false
          cancelable: false
          detail: `undefined`

        evt = document.createEvent "CustomEvent"
        evt.initCustomEvent event, params.bubbles, params.cancelable, params.detail
        evt
      CustomEvent:: = window.Event::
      window.CustomEvent = CustomEvent

  # -------------------------------------------

  trigger: (eventName, eventData='') ->
    event = new CustomEvent(eventName, {detail:eventData})
    document.dispatchEvent event

  # -------------------------------------------

  listenTo: (eventName, cb, onlyOnce = false) ->

    _callback = (e) =>
      @stopListeningTo eventName, _callback if onlyOnce
      cb e.detail, e

    document.addEventListener eventName, _callback, false

    return _callback

  # -------------------------------------------

  listenOnce: (eventName, cb) ->
    @listenTo eventName, cb, true

  # -------------------------------------------

  stopListeningTo: (eventName, cb) ->
    document.removeEventListener eventName, cb, false

  # -------------------------------------------

module.exports = EventManager.getInstance()


// WEBPACK FOOTER //
// ./coffee/manager/event-manager.coffee